import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { useGetPaymentQuery } from '../apis/PaymentMethodApi';
 import { getUserData } from '../auth';
import { useGetBalanceQuery } from '../apis/BalanceApi';
import { useDispatch, useSelector } from 'react-redux';
import { useCreateOrderMutation } from '../apis/OrderAPi';
import { useForm } from 'react-hook-form';
import { resetCart } from '../common/slices/productSlice';
import { Tooltip } from '@mui/material';
import _ from "lodash";

const CheckoutAmazon = () => {
     const {
        register,
        handleSubmit,
        formState: { errors },
      } = useForm();
    
  const [create, { isLoading:isLoadingCreate, isSuccess, isError:isErrorCreate, error:errorCreate }] =
  useCreateOrderMutation();

    
const [selectedItem, setSelectedItem] = useState(null);
const cartItems = useSelector((state) => state.product.cart); 
//console.log('cartItems cartItems',cartItems)
const dispach=useDispatch();
const navigate=useNavigate();
// Access cart items from Redux store
const paymentMethod = useSelector((state) => state.product?.selectedPayemntMethode); // Access cart items from Redux store
 

const userData = getUserData();
const userId = userData?.uid || "";

function generateOrderNumber(userID) {
    const now = new Date();
  
    // Format date as YYMMDD
    const year = now.getFullYear().toString().slice(-2); // Get last 2 digits of year
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(now.getDate()).padStart(2, '0');
  
    // Get current timestamp in seconds
    const seconds = Math.floor(Date.now() / 1000).toString();
  
    // Combine all parts
    return `ORD-${year}${month}${day}-${userID}${seconds}`;
  }
const transformedData = {
           
    id: 0,  // Vendor Store ID (it can be dynamic if needed)
    totalPrice: cartItems.reduce((total, product) => total + (product.price-product.discount) * product.quantity, 0),
    quantiteTotal: cartItems.reduce((total, product) => total + product.quantity, 0),
    status: "pending",  // You can set the actual status here
    paymentMethod:"",  // You can define a specific payment method here
     
    orderNumber:generateOrderNumber(userId),
    orderDate: new Date().toISOString(),  // Set the order date as the current timestamp
    deliveryDateTime: "",  // Define delivery date here
    refundOrderDate:"",
    month: new Date().toLocaleString("default", { month: "long" }), // Get the current month as a string (e.g., "January")
    year: new Date().getFullYear().toString(), // Get the current year as a string

    items: cartItems.map(product => ({
       quantity: product.quantity,
      price:  (product.price-product.discount),
      total: (product.price-product.discount) * product.quantity,
      commissionRate:product?.adminCommissionRate|| 0.20,  // 20% commission rate
      vendorCommissionFee: (product.price-product.discount) * product.quantity * 0.20,  // Vendor commission fee
      statusVendorTracker: "Verifying",  // Set vendor tracker status
      commentVendorTracker: "No Comment",  // Set a comment related to the vendor tracker
      statusCustomerTracker: "Pending",  // Define customer tracker status

      statusCommission:"not pay", // or pay
      validateDateTime:"",     /// time date of the update of statusCommission

      userName: product?.userName,  
      shopName: product?.shopName, 
      sellerId:product?.sellerId,
      shopProfileId:product?.shopProfileId,
       productId: product.id, // Reference to the product ID
      productName: product.name, // Name of the product
      description: product.description, // Description of the product
      taxRate: product.taxRate ?? 0, // Tax rate applied to the product, default to 0
      benefice: product.benefice ?? 0, // Benefice or profit margin, default to 0
      productPrice: product.price ?? 0, // Product price at the time of order
      discount: (product.price-product.discount) ?? 0, // Discount applied, default to 0
      sku: product.sku ?? "", // Stock Keeping Unit (SKU), default to an empty string
      ratings: product.ratings ?? 0, // Product ratings, default to 0
      status: product.status ?? "", // Product status (e.g., "Published"), default to an empty string
      images: product.images ?? [], // Product images, default to an empty array   
    })),
    active: true  // You can set whether the order is active or not

    };


    const { data: balanceData, isLoading:isLoadingBalance, error:errorBalance, refetch } = useGetBalanceQuery (userId);
    // console.log('balanceData',balanceData);

 
    const myBalance = balanceData ? balanceData :
    {
      id: 0,
      balance:0
    }

 const newBalance=myBalance?.balance-transformedData?.totalPrice; 

  // Fetch data from PaymentApi using the useGetPaymentQuery hook
  const { data: paymentData, isLoading, error } = useGetPaymentQuery();

  // This is a fallback or a mock of the wallet items in case the API call fails
  const items = paymentData ? paymentData : [
    {
      id: 1,
      name: " ",
      walletAdress: " ",
      imageUrl: " ",
    }, 
  ];
 
  
  const onSubmit = async (data) => {
   
       // Update the order with the selected payment method
          const createOrder = {
           ...data,
           ...transformedData,
           paymentMethod: paymentMethod, // Update with selected payment method
         };
     
         // Log the transformed data for debugging
        // console.log("Transformed Data:", createOrder);
        // console.log("Transformed data:", data);
   
         // Proceed with mutation if form is valid
         try {
           // Call mutation to create the order with the updated paymentMethod
           await create({ user_id: userId, Cart: createOrder }).unwrap();
           alert("Order successfully submitted!");
           dispach(resetCart())
           navigate('/customer-orders')
         } catch (error) {
           console.error("Error submitting order:", error);
           alert("Error submitting the order.");
         }
     
        
     }; 
      if (isLoading && isLoadingBalance) {
        return <div>Loading...</div>;
      }
     
    
// Place hooks after the early returns 
    return (
        <section className="checkout py-80">
            <div className="container container-lg">
              
                <div className="row">
                <div className="col-xl-9 col-lg-8">
  <form className="pe-xl-5" onSubmit={handleSubmit(onSubmit)}>
    <div className="row gy-3">
      {/* First Name */}
      <div className="col-sm-6 col-xs-6">
        <input
          type="text"
          {...register("firstName", { required: "First name is required" })}
          className={`common-input border-gray-100 ${errors.firstName ? "is-invalid" : ""}`}
          placeholder="First Name"
        />
        {errors.firstName && (
          <small className="text-danger">{errors.firstName.message}</small>
        )}
      </div>

      {/* Last Name */}
      <div className="col-sm-6 col-xs-6">
        <input
          type="text"
          {...register("lastName", { required: "Last name is required" })}
          className={`common-input border-gray-100 ${errors.lastName ? "is-invalid" : ""}`}
          placeholder="Last Name"
        />
        {errors.lastName && (
          <small className="text-danger">{errors.lastName.message}</small>
        )}
      </div>

      {/* Street Name */}
      <div className="col-12">
        <input
          type="text"
          {...register("streetName", { required: "Street name is required" })}
          className={`common-input border-gray-100 ${errors.streetName ? "is-invalid" : ""}`}
          placeholder="House number and street name"
        />
        {errors.streetName && (
          <small className="text-danger">{errors.streetName.message}</small>
        )}
      </div>

      {/* City */}
      <div className="col-12">
        <input
          type="text"
          {...register("city", { required: "City is required" })}
          className={`common-input border-gray-100 ${errors.city ? "is-invalid" : ""}`}
          placeholder="City"
        />
        {errors.city && (
          <small className="text-danger">{errors.city.message}</small>
        )}
      </div>

       {/* Contry */}
       <div className="col-12">
        <input
          type="text"
          {...register("apartment")}
          className="common-input border-gray-100"
          placeholder="Contry"
        />
      </div>

      {/* Post Code */}
      <div className="col-12">
        <input
          type="text"
          {...register("postCode", { required: "Post code is required" })}
          className={`common-input border-gray-100 ${errors.postCode ? "is-invalid" : ""}`}
          placeholder="Post Code"
        />
        {errors.postCode && (
          <small className="text-danger">{errors.postCode.message}</small>
        )}
      </div>

      {/* Phone */}
      <div className="col-12">
        <input
          type="number"
          {...register("phone", {
            required: "Phone number is required",
            minLength: { value: 10, message: "Phone number must be at least 10 digits" },
          })}
          className={`common-input border-gray-100 ${errors.phone ? "is-invalid" : ""}`}
          placeholder="Phone"
        />
        {errors.phone && (
          <small className="text-danger">{errors.phone.message}</small>
        )}
      </div>

      {/* Email */}
      <div className="col-12">
        <input
          type="email"
          {...register("email", {
            required: "Email is required",
            pattern: {
              value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
              message: "Invalid email address",
            },
          })}
          className={`common-input border-gray-100 ${errors.email ? "is-invalid" : ""}`}
          placeholder="Email Address"
        />
        {errors.email && (
          <small className="text-danger">{errors.email.message}</small>
        )}
      </div>

      {/* Submit Button */}
      <div className="col-12">
    
      <button
  type="submit"
  disabled={isLoadingCreate || myBalance?.balance < transformedData.totalPrice}
  className={`btn btn-main mt-40 py-18 w-100 rounded-8 mt-56 ${
    myBalance?.balance < transformedData.totalPrice ? "disabled" : ""
  }`}
>
  {isLoadingCreate ? 'Submitting...' : 'Place Order'}
</button>

    {/* Show success message */}
    {isSuccess && <p className="text-green-500 mt-4">Order created successfully!</p>}

{/* Show error message */}
{isErrorCreate && <p className="text-red-500 mt-4">Error: {errorCreate?.message || 'Failed to create.'}</p>}
      </div>
    </div>
    </form>


    </div>


                    <div className="col-xl-3 col-lg-4">
                        <div className="checkout-sidebar">
                            <div className="bg-color-three rounded-8 p-24 text-center">
                                <span className="text-gray-900 text-xl fw-semibold">
                                    Your Orders
                                </span>
                            </div>
                            <div className="border border-gray-100 rounded-8 px-24 py-40 mt-24">
                                <div className="mb-32 pb-32 border-bottom border-gray-100 flex-between gap-8">
                                    <span className="text-gray-900 fw-medium text-xl font-heading-two">
                                        Product
                                    </span>
                                    <span className="text-gray-900 fw-medium text-xl font-heading-two">
                                        Subtotal
                                    </span>
                                </div> 
                                {transformedData?.items.map((item) => (
          <div className="flex-between gap-24 mb-32" key={item.id}>
            <div className="flex-align gap-12">
              <span className="text-gray-900 fw-normal text-md font-heading-two w-144">
                 <Tooltip title={item.productName} arrow>
                     {_.truncate(item.productName, { length: 10, omission: "..." })}
                 </Tooltip>
              </span>
              <span className="text-gray-900 fw-normal text-md font-heading-two">
                <i className="ph-bold ph-x" />
              </span>
              <span className="text-gray-900 fw-semibold text-md font-heading-two">
                {item.quantity}
              </span>
            </div>
            <span className="text-gray-900 fw-bold text-md font-heading-two">
              ${item.total}
            </span>
          </div>
        ))}
                                <div className="border-top border-gray-100 pt-30  mt-30">
                                    <div className="mb-32 flex-between gap-8">
                                        <span className="text-gray-900 font-heading-two text-xl fw-semibold">
                                            Subtotal
                                        </span>
                                        <span className="text-gray-900 font-heading-two text-md fw-bold">
                                            ${transformedData?.totalPrice}
                                        </span>
                                    </div>
                                    <div className="mb-32 flex-between gap-8">
                                        <span className="text-gray-900 font-heading-two text-xl fw-semibold">
                                            Total 
                                        </span>
                                        <span className="text-gray-900 font-heading-two text-md fw-bold">
                                            ${transformedData?.totalPrice}
                                        </span>
                                    </div>
                                    
                                    <div className="mb-0 flex-between gap-8">
                                        <span className="text-gray-900 font-heading-two text-xl fw-semibold">
                                            Wallet 
                                        </span>
                                        <span className="text-gray-900 font-heading-two text-md fw-bold">
                                             {myBalance?.balance}
                                        </span>
                                    </div>
                                    <div className="mb-0 flex-between gap-8">
                                        <span className="text-gray-900 font-heading-two text-xl fw-semibold">
                                            New Blance 
                                        </span>
                                        <span className="text-gray-900 font-heading-two text-md fw-bold">
                                             {newBalance}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="mt-32 pt-32 border-top border-gray-100">
                                <p className="text-gray-500">
                                    Your personal data will be used to process your order, support
                                    your experience throughout this website, and for other purposes
                                    described in our{" "}
                                    <Link to="#" className="text-main-600 text-decoration-underline">
                                        {" "}
                                        privacy policy
                                    </Link>{" "}
                                    .
                                </p>
                            </div>

                           
     
                        </div>
                    </div>
                    
                </div>
                
            </div>
        </section>

    )
}

export default CheckoutAmazon